import { ReactComponent as Option } from "assets/SidebarIcons/orange-treelist.svg";

import { Button } from "components/Button";
import { IOccurrence } from "interfaces/Occurrence";
import { ColumnHeader } from "./ColumnHeader";
import { useAuth } from "contexts/authContext";

type OptionsProps = {
  occurrence: IOccurrence;
  priorizedCard: (isFavorite: boolean, occurrenceId: string) => void;
  attachmentsClick: () => void
  handleOccurrenceEdit: () => void
  commentsClick: () => void
  copyShareLink: (occurrence: IOccurrence) => Promise<void>
  cancelClick: () => void
}

export function Options({ occurrence, priorizedCard, attachmentsClick, commentsClick, handleOccurrenceEdit, cancelClick, copyShareLink }: OptionsProps) {
  const {role} = useAuth()
  return (
    <div>
      <ColumnHeader icon={<Option />} title="Opções" />

      <article>
        {occurrence.report && occurrence.report?.length > 0 && (
          <Button
            type="button"
            variant="onboarding"
            title="Anexos"
            onClick={() => attachmentsClick()}
          />
        )}

        <Button
          type="button"
          variant="onboarding"
          title="Gerenciar ocorrência"
          onClick={handleOccurrenceEdit}
        />
        <Button
          type="button"
          variant="onboarding"
          title="Comentários"
          onClick={commentsClick}
        />
        <Button
          type="button"
          variant="onboarding"
          title="Compartilhar"
          onClick={() => copyShareLink(occurrence)}
        />

        {occurrence.status !== "aguardando_cancelamento" && (
          <Button
            type="button"
            variant="error"
            title="Cancelar"
            disabled={ role !== "master" }
            onClick={cancelClick}
          />
        )}
      </article>
    </div>
  );
}